export const MEASURU_DATA_SUCCESS = 'MEASURU_DATA_SUCCESS';
export const MEASURU_DATA_CLEAR = 'MEASURU_DATA_CLEAR';